

/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../constants";
import { fetchData } from "../../../helpers";
// getCartItems
// GETCARTTREMS
const GETCARTTREMS= createAsyncThunk(
  "getCartItems/getCartItems",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const getCartItemsSlice = createSlice({
  name: "getCartItemsSlice",
  initialState: {
    getCartItems: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfgetCartItems: (state) => {
        state.getCartItems.loading = false
        state.getCartItems.error = false
        state.getCartItems.data = []
        state.getCartItems.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(GETCARTTREMS.fulfilled, (state, action) => {
      state.getCartItems = {
        ...state.getCartItems,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(GETCARTTREMS.pending, (state, action) => {
      state.getCartItems = {
        ...state.getCartItems,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(GETCARTTREMS.rejected, (state, action) => {
      state.getCartItems = {
        ...state.getCartItems,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const getCartItemsAction = {
    GETCARTTREMS,
};

export { getCartItemsAction };
export default getCartItemsSlice.reducer;
export const {setInitialStateOfgetCartItems} = getCartItemsSlice.actions
